// extracted by mini-css-extract-plugin
module.exports = {"header":"Brand_header__yE_PZ"};